function ItemAllIconsComponent() {
  return <div className="allIcons"></div>;
}

export { ItemAllIconsComponent };
